export default {
    FiliadoMilitante: axios.create({
        baseURL: process.env.VUE_APP_ENDPOINT_API + "filiado-militante"
    })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/FiliadoMilitante.js
// module id = xx31
// module chunks = 18